import * as React from "react";
const SvgDashedLine = (props) => /* @__PURE__ */ React.createElement("svg", { height: 1, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 0.5, y1: 0.5, x2: "100%", y2: 0.499977, stroke: "#76728E", strokeWidth: 0.6, strokeLinecap: "round", strokeDasharray: "4 1.5" }));
export default SvgDashedLine;
